/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import Layout from "../../layout/Main/Layout";
import CustomTable from "../../components/Custom/Table/CustomTable";
import { get, put, post, postFiles, patch } from "../../config/axios";
import {  Box,
  Modal,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  CircularProgress, 
  DialogTitle,
  Divider,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TextField,
  Chip,
  MenuItem,
  IconButton,
  Avatar,
  Select,
  FormControl,
  InputLabel} from "@mui/material";
  

import Searchbar from "../../components/Custom/SearchBar/Searchbar";

import { useDebouncedValue } from "../../helper/debounce";
import { toastMessage } from "../../utils/toastMessage";

import { MasterFoodTableColumns } from "../../constants/MasterFood";
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import EditIcon from '@mui/icons-material/Edit';


const MasterFood = () => {
  // Predefined ingredient categories similar to shopping list structure
  const ingredientCategories = [
    "Vegetables",
    "Proteins", 
    "Grains",
    "Dairy",
    "Spices",
    "Oils",
    "Fruits",
    "Nuts",
    "Herbs",
    "Condiments",
    "Beverages",
    "Seafood",
    "Meat",
    "Poultry",
    "Legumes",
    "Other"
  ];

  const [users, setUsers] = useState([]);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteUser, setDeleteUser] = useState("");
  const [search, setSearch] = useState("");
  const [message, setMessage] = useState("");
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const debouncedSearch = useDebouncedValue(search, 500);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [mealPlans, setMealPlans] = useState([]);
  const [selectedMealPlan, setSelectedMealPlan] = useState("");
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [newTag, setNewTag] = useState("");
  const [imageUploadModal, setImageUploadModal] = useState(false);
  const [selectedFoodForImage, setSelectedFoodForImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);
  
  // Edit modal image upload states
  const [editImageFile, setEditImageFile] = useState(null);
  const [editImagePreview, setEditImagePreview] = useState(null);
  const [uploadingEditImage, setUploadingEditImage] = useState(false);
  
  // Category filter states
  const [coreCategoryFilter, setCoreCategoryFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [subCategoryFilter, setSubCategoryFilter] = useState("");
  const [fodmapFilter, setFodmapFilter] = useState("");
const fetchMealPlans = async (searchValue) => {
    try {
      setLoading(true);
  
      const res = await get(
        `/api/app/diet/masterFoodGetAdmin?page=${page}&limit=10&search=${searchValue}`

      );
      console.log("- API Response:", res); // Log the entire response for debugging
  
      // Accessing directly from the response object, not res.data
      const { data, total, totalPages } = res; // Correct access from res
  
      if (!data) {
        console.error("Missing mealPlans data:", res);
        setLoading(false);
        return;
      }
  
      const enrichedPlans = data.map((plan, index) => ({
        ...plan,
        SNo: (page - 1) * 10 + index + 1,
        action: { edit: true, delete: true },
        patientName: plan.name ? plan.name : "Unknown", 
        image: plan.image || null,
        coreCategory: plan.coreCategory || "N/A",
        category: plan.category || "N/A",
        subCategory: plan.subCategory || "N/A",
        fodmap: plan.fod_map?.value || "N/A",
        calories: plan.nutrition ? plan.nutrition.calories : "Unknown", 
        carbs: plan.nutrition? plan.nutrition.carbs : "Unknown", 
        fat: plan.nutrition ? plan.nutrition.fat : "Unknown", 
        fiber: plan.nutrition ? plan.nutrition.fiber : "Unknown", 
        protein: plan.nutrition ? plan.nutrition.protein : "Unknown", 
        createdAt: format(new Date(plan.createdAt), "dd MMM yyyy"),
        updatedAt: format(new Date(plan.updatedAt), "dd MMM yyyy"),
      }));
  
      setMealPlans(enrichedPlans);
      setPageCount(totalPages);
      setTotalData(total);
      setPerPage(10);
      setCurrentPage(page);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch meal plans:", error);
      setLoading(false);
    }
  };
  

const addTag = () => {
  if (
    newTag.trim() !== "" &&
    !selectedMealPlan.tags?.includes(newTag.trim())
  ) {
    setSelectedMealPlan((prev) => ({
      ...prev,
      tags: [...(prev.tags || []), newTag.trim()],
    }));
    setNewTag("");
  }
};

const resetFilters = () => {
  setCoreCategoryFilter("");
  setCategoryFilter("");
  setSubCategoryFilter("");
  setFodmapFilter("");
};



useEffect(() => {
    // Only call fetchMealPlans when debouncedSearch or page changes
    if (debouncedSearch !== "") {
      fetchMealPlans(debouncedSearch);
    } else {
      fetchMealPlans("");  // If the search is empty, fetch with an empty string
    }
  }, [debouncedSearch, page]);
  
  useEffect(() => {
    // Refetch data when filters change
    fetchMealPlans(searchValue);
  }, [coreCategoryFilter, categoryFilter, subCategoryFilter, fodmapFilter]);

  const handleEdit = (row) => {
    // Implement the edit action for the selected row
    openModal("edit", row);
  };


 
  
// Handle page change
  const handlePageChange = (page) => {
    setPage(page);
  };

  // Image upload handlers - Direct upload without modal
  const handleImageUpload = (foodItem) => {
    // Create a hidden file input
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.style.display = 'none';
    
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      // Validate file type
      if (!file.type.startsWith('image/')) {
        toastMessage('Please select a valid image file', 'error');
        return;
      }

      try {
        // Create FormData for file upload
        const formData = new FormData();
        formData.append('image', file);
        formData.append('foodId', foodItem._id);

        // Upload image using postFiles
        const response = await postFiles('/api/app/diet/uploadFoodImage', formData);
        
        if (response?.data?.success) {
          toastMessage('Image uploaded successfully!', 'success');
          
          // Update the local state
          setMealPlans(prev => prev.map(item => 
            item._id === foodItem._id 
              ? { ...item, image: response.data.data.imageUrl }
              : item
          ));
        } else {
          toastMessage(response?.data?.message || 'Failed to upload image', 'error');
        }
      } catch (error) {
        console.error('Error uploading image:', error);
        toastMessage('Error uploading image', 'error');
      }
    };
    
    // Trigger file selection
    document.body.appendChild(input);
    input.click();
    document.body.removeChild(input);
  };

  const handleImageFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageUploadSubmit = async () => {
    if (!imageFile || !selectedFoodForImage) return;

    try {
      setUploadingImage(true);
      
      // Validate file
      if (!imageFile.type.startsWith('image/')) {
        toastMessage('Please select a valid image file', 'error');
        setUploadingImage(false);
        return;
      }
      
      // Create FormData for file upload
      const formData = new FormData();
      formData.append('image', imageFile);
      formData.append('foodId', selectedFoodForImage._id);

      // Upload image using postFiles
      const response = await postFiles('/api/app/diet/uploadFoodImage', formData);
      
      if (response?.data?.success) {
        toastMessage('Image uploaded successfully!', 'success');
        
        // Update the local state
        setMealPlans(prev => prev.map(item => 
          item._id === selectedFoodForImage._id 
            ? { ...item, image: response.data.data.imageUrl }
            : item
        ));
        
        // Close modal and reset state
        setImageUploadModal(false);
        setSelectedFoodForImage(null);
        setImageFile(null);
        setImagePreview(null);
      } else {
        toastMessage(response?.data?.message || 'Failed to upload image', 'error');
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      toastMessage('Error uploading image', 'error');
    } finally {
      setUploadingImage(false);
    }
  };

  const handleCloseImageModal = () => {
    setImageUploadModal(false);
    setSelectedFoodForImage(null);
    setImageFile(null);
    setImagePreview(null);
  };

  // Edit modal image upload handlers
  const handleEditImageFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setEditImageFile(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setEditImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEditImageUpload = async () => {
    if (!editImageFile || !selectedMealPlan) return;

    try {
      setUploadingEditImage(true);
      
      // Validate file
      if (!editImageFile.type.startsWith('image/')) {
        toastMessage('Please select a valid image file', 'error');
        setUploadingEditImage(false);
        return;
      }
      
      // Create FormData for file upload
      const formData = new FormData();
      formData.append('image', editImageFile);
      formData.append('foodId', selectedMealPlan._id);

      // Upload image using postFiles
      const response = await postFiles('/api/app/diet/uploadFoodImage', formData);
      
      if (response?.data?.success) {
        toastMessage('Image uploaded successfully!', 'success');
        
        // Update the selectedMealPlan with the new image URL
        setSelectedMealPlan(prev => ({
          ...prev,
          image: response.data.data.imageUrl
        }));
        
        // Update the local mealPlans state
        setMealPlans(prev => prev.map(item => 
          item._id === selectedMealPlan._id 
            ? { ...item, image: response.data.data.imageUrl }
            : item
        ));
        
        // Reset edit image states
        setEditImageFile(null);
        setEditImagePreview(null);
      } else {
        toastMessage(response?.data?.message || 'Failed to upload image', 'error');
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      toastMessage('Error uploading image', 'error');
    } finally {
      setUploadingEditImage(false);
    }
  };

  const handleDelete = (row) => {
    openModal("delete", row);
  };

  const handleStatus = (row) => {
    // Implement the status chnage for the selected row
    console.log("Delete clicked for row34:", row);
  };

  const handleActive = async (planId, active) => {
    setLoading(true);
     try {
    const res = await put(`/api/app/diet/toggleMealPlanActive/${planId}/active`, {
      active: active
    });

    console.log("Active status updated:", res.data);
    // Optionally update UI state
  } catch (err) {
    console.error("Failed to update active status:", err);
  }
    setLoading(false);
   
    const message = active
    ? `Status has been successfully activated.`
    : `Status has been successfully deactivated.`;
    setMessage(message);
    toastMessage(message, "success");
  };

  const handleSearch = (searchText) => {
    setSearch(searchText.trim());
    setSearchValue(searchText.trim());
    setPage(1);
  };



  const openModal = (type, dataForEdit) => {
    if (type === "add") {
      setIsModalOpen(true);
    } else if (type === "edit") {
      setEditModal(true);
      setSelectedMealPlan(dataForEdit);
      // Reset edit image states when opening edit modal
      setEditImageFile(null);
      setEditImagePreview(null);
      setUploadingEditImage(false);
    } else if (type === "delete") {
      setDeleteModalOpen(true);
      setDeleteUser(dataForEdit);
    }
  };


  const handleDisplay = async (rowData) => {
    // Implement the edit action for the selected row
    
    try {
        // const res = await get(`/api/app/diet/meal-plan/${rowData._id}`);
        // console.log("Viewing meal plan:", res);
        
        // Ensure all data structures are properly initialized
        const foodData = {
          ...rowData,
          recipe: {
            ingredients: rowData.recipe?.ingredients || [],
            preparationSteps: rowData.recipe?.preparationSteps || [],
            preparationTime: rowData.recipe?.preparationTime || 0,
            ...rowData.recipe
          },
          benefits: rowData.benefits || [],
          tags: rowData.tags || [],
          images: rowData.images || {},
          alternatives: rowData.alternatives || []
        };
        
        setSelectedMealPlan(foodData);
        console.log("---------->><>>", foodData);
        console.log("Preparation steps initialized:", foodData.recipe?.preparationSteps);
        setViewModalOpen(true);
      } catch (error) {
        toastMessage("Failed to load meal plan details", "error");
      }
  };

const handleSave = async () => {
    setLoading(true);
    try {
      // Debug: Log the data being sent
      console.log("Saving food data:", selectedMealPlan);
      console.log("Preparation steps:", selectedMealPlan.recipe?.preparationSteps);
      console.log("Preparation time:", selectedMealPlan.recipe?.preparationTime);
      
      const res =  await put(
      `/api/app/diet/masterFoodUpdate/${selectedMealPlan._id}`,
      selectedMealPlan
    );
      const updatedPlan = res.data;
      
      console.log("Update response:", res);
      toastMessage("Meal plan updated successfully!", "success");
      await fetchMealPlans(searchValue);
      
      // Close modal and reset edit image states after successful save
      setEditModal(false);
      setEditImageFile(null);
      setEditImagePreview(null);
      setUploadingEditImage(false);
    } catch (err) {
      console.error("Error updating meal plan:", err);
      toastMessage("Server error. Please try again later.", "error");
    } finally {
      setLoading(false);
    }
  };
  

  
  
  return (
    <>
      <Layout>
        <div style={{ padding: "1rem" }}>
          <Typography variant="h5">Master Food</Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            
            
            {/* Category Filters */}
            <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
              <div style={{ width: "30%", display: "flex", gap: "8px" }}>
              <TextField
                fullWidth
                placeholder="Search by Name"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleSearch(e.target.value);
                  }
                }}
                size="small"
              />
              <Button
                variant="contained"
                size="small"
                onClick={() => handleSearch(search)}
                sx={{ minWidth: '80px' }}
              >
                Search
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  setSearch("");
                  setSearchValue("");
                  setPage(1);
                }}
                sx={{ minWidth: '80px' }}
              >
                Clear
              </Button>
            </div>
              <TextField
                select
                label="Core Category"
                size="small"
                style={{ minWidth: 150 }}
                value={coreCategoryFilter}
                onChange={(e) => setCoreCategoryFilter(e.target.value)}
              >
                <MenuItem value="">All</MenuItem>
                {Array.from(new Set(mealPlans.map(item => item.coreCategory).filter(Boolean))).map((category) => (
                  <MenuItem key={category} value={category}>
                    {category}
                  </MenuItem>
                ))}
              </TextField>
              
              <TextField
                select
                label="Category"
                size="small"
                style={{ minWidth: 150 }}
                value={categoryFilter}
                onChange={(e) => setCategoryFilter(e.target.value)}
              >
                <MenuItem value="">All</MenuItem>
                {Array.from(new Set(mealPlans.map(item => item.category).filter(Boolean))).map((category) => (
                  <MenuItem key={category} value={category}>
                    {category}
                  </MenuItem>
                ))}
              </TextField>
              
              <TextField
                select
                label="Sub Category"
                size="small"
                style={{ minWidth: 150 }}
                value={subCategoryFilter}
                onChange={(e) => setSubCategoryFilter(e.target.value)}
              >
                <MenuItem value="">All</MenuItem>
                {Array.from(new Set(mealPlans.map(item => item.subCategory).filter(Boolean))).map((category) => (
                  <MenuItem key={category} value={category}>
                    {category}
                  </MenuItem>
                ))}
              </TextField>
              
              <TextField
                select
                label="FODMAP Level"
                size="small"
                style={{ minWidth: 150 }}
                value={fodmapFilter}
                onChange={(e) => setFodmapFilter(e.target.value)}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="Low">Low FODMAP</MenuItem>
                <MenuItem value="Medium">Medium FODMAP</MenuItem>
                <MenuItem value="Moderate">Moderate FODMAP</MenuItem>
                <MenuItem value="High">High FODMAP</MenuItem>
              </TextField>
              
              <Button
                variant="outlined"
                onClick={resetFilters}
                size="small"
              >
                Reset
              </Button>
            </div>

            {/* <Button
              onClick={() => openModal("add")}
              variant="outlined"
              startIcon={<AddIcon fontSize="large" />}
              style={{ fontWeight: "bold" }}
            >
              add new diet content
            </Button> */}
          </div>
          
          {/* Category Statistics - Hidden */}
          {/* <Box sx={{ mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Food Distribution by Category
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Box sx={{ p: 2, bgcolor: 'primary.main', color: 'white', borderRadius: 1, minWidth: 120, textAlign: 'center' }}>
                <Typography variant="h4">{Array.from(new Set(mealPlans.map(item => item.coreCategory).filter(Boolean))).length}</Typography>
                <Typography variant="body2">Core Categories</Typography>
              </Box>
              <Box sx={{ p: 2, bgcolor: 'secondary.main', color: 'white', borderRadius: 1, minWidth: 120, textAlign: 'center' }}>
                <Typography variant="h4">{Array.from(new Set(mealPlans.map(item => item.category).filter(Boolean))).length}</Typography>
                <Typography variant="body2">Categories</Typography>
              </Box>
              <Box sx={{ p: 2, bgcolor: 'success.main', color: 'white', borderRadius: 1, minWidth: 120, textAlign: 'center' }}>
                <Typography variant="h4">{Array.from(new Set(mealPlans.map(item => item.subCategory).filter(Boolean))).length}</Typography>
                <Typography variant="body2">Sub Categories</Typography>
              </Box>
              <Box sx={{ p: 2, bgcolor: 'info.main', color: 'white', borderRadius: 1, minWidth: 120, textAlign: 'center' }}>
                <Typography variant="h4">{mealPlans.length}</Typography>
                <Typography variant="body2">Total Foods</Typography>
              </Box>
            </Box>
          </Box> */}
          
          {/* Filter Summary */}
          {(coreCategoryFilter || categoryFilter || subCategoryFilter || fodmapFilter) && (
            <Box sx={{ mb: 2, p: 2, bgcolor: 'background.paper', borderRadius: 1, border: 1, borderColor: 'divider' }}>
              <Typography variant="body2" color="textSecondary">
                Showing {mealPlans.filter(item => {
                  if (coreCategoryFilter && item.coreCategory !== coreCategoryFilter) return false;
                  if (categoryFilter && item.category !== categoryFilter) return false;
                  if (subCategoryFilter && item.subCategory !== subCategoryFilter) return false;
                  if (fodmapFilter && item.fodmap !== fodmapFilter) return false;
                  return true;
                }).length} of {mealPlans.length} foods
                {coreCategoryFilter && ` • Core Category: ${coreCategoryFilter}`}
                {categoryFilter && ` • Category: ${categoryFilter}`}
                {subCategoryFilter && ` • Sub Category: ${subCategoryFilter}`}
                {fodmapFilter && ` • FODMAP: ${fodmapFilter}`}
              </Typography>
            </Box>
          )}
          
          <CustomTable
        data={mealPlans.filter(item => {
          if (coreCategoryFilter && item.coreCategory !== coreCategoryFilter) return false;
          if (categoryFilter && item.category !== categoryFilter) return false;
          if (subCategoryFilter && item.subCategory !== subCategoryFilter) return false;
          if (fodmapFilter && item.fodmap !== fodmapFilter) return false;
          return true;
        })}
        columns={MasterFoodTableColumns}  // Pass handleView here
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleStatus={handleStatus}
        handleDisplay={handleDisplay}
        handleActive={(row, active) => handleActive(row, active)}
        handlePageChange={handlePageChange}
        handleImageUpload={handleImageUpload}
        pageNumber={page}
        pageCount={pageCount}
        totalData={totalData}
        perPage={perPage}
        currentPage={currentPage}
        loading={loading}
      />
      
      {/* Modal to display weekly plan */}
      <Dialog
            open={viewModalOpen}
            onClose={() => setViewModalOpen(false)}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>Recipe for {selectedMealPlan.name}</DialogTitle>
            <DialogContent dividers>
  <Typography variant="body2" gutterBottom>
    Created Date: {new Date(selectedMealPlan.createdAt).toLocaleDateString()} | Updated Date: {new Date(selectedMealPlan.updatedAt).toLocaleDateString()}
  </Typography>
  {/* <Typography variant="body2" gutterBottom>
    Total Weeks: {selectedMealPlan.totalWeeks} | Total Meals: {selectedMealPlan.totalMeals}
  </Typography> */}
  {/* <Typography variant="body2" gutterBottom>
    Recipe: {selectedMealPlan.mealTypes?.join(', ')}
  </Typography>
  <Divider sx={{ my: 2 }} /> */}
{selectedMealPlan.tags?.length > 0 && (
  <Box sx={{ my: 2 }}>
    <Typography variant="subtitle2">Tags</Typography>
    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
      {selectedMealPlan.tags.map((tag, i) => (
        <Chip key={i} label={tag} variant="outlined" color="primary" />
      ))}
    </Box>
  </Box>
)}

  {selectedMealPlan && (
  <div style={{ marginBottom: "2rem" }}>
    <Typography variant="h6" gutterBottom>
      {selectedMealPlan.name}
    </Typography>

    <Typography variant="body2" gutterBottom>
      Quantity: {selectedMealPlan.quantity?.value} {selectedMealPlan.quantity?.unit}
    </Typography>

    <Typography variant="body2" gutterBottom>
      Calories: {selectedMealPlan.nutrition?.calories} | Protein: {selectedMealPlan.nutrition?.protein}g | 
      Carbs: {selectedMealPlan.nutrition?.carbs}g | Fat: {selectedMealPlan.nutrition?.fat}g | Fiber: {selectedMealPlan.nutrition?.fiber}g
    </Typography>

    <Paper variant="outlined" sx={{ overflowX: "auto", mt: 2 }}>
      <Typography variant="subtitle1" sx={{ p: 2 }}>
        Ingredients
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Item</TableCell>
            <TableCell>Quantity</TableCell>
            <TableCell>Unit</TableCell>
            <TableCell>Category</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {selectedMealPlan.recipe?.ingredients?.map((ingredient, i) => (
            <TableRow key={i}>
              <TableCell>{ingredient.item}</TableCell>
              <TableCell>{ingredient.quantity}</TableCell>
              <TableCell>{ingredient.unit}</TableCell>
              <TableCell>{ingredient.category || "-"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Box sx={{ p: 2 }}>
        <Typography variant="subtitle1" gutterBottom>
          Preparation Steps
        </Typography>
        <ol>
          {selectedMealPlan.recipe?.preparationSteps?.map((step, i) => (
            <li key={i}>{step}</li>
          ))}
        </ol>

        <Typography variant="body2" color="text.secondary">
          Preparation Time: {selectedMealPlan.recipe?.preparationTime} minutes
        </Typography>
        
      </Box>
    </Paper>

    <Divider sx={{ my: 3 }} />
  </div>
)}


</DialogContent>
      </Dialog> 
      

<Dialog
  open={editModal}
  onClose={() => setEditModal(false)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>Edit Meal Plan: {selectedMealPlan?.name}</DialogTitle>
  <DialogContent dividers>
    <Typography variant="body2" gutterBottom>
      Created Date: {new Date(selectedMealPlan.createdAt).toLocaleDateString()} | Updated Date:{" "}
      {new Date(selectedMealPlan.updatedAt).toLocaleDateString()}
    </Typography>

    <TextField
      fullWidth
      label="Meal Plan Name"
      value={selectedMealPlan.name}
      onChange={(e) => setSelectedMealPlan((prev) => ({ ...prev, name: e.target.value }))}
      sx={{ mb: 2 }}
    />

    {/* Category Fields */}
    <Typography variant="subtitle1" sx={{ mt: 3, mb: 2 }}>
      Categories
    </Typography>
    
    <Box display="flex" gap={2} mb={2}>
      <FormControl fullWidth>
        <InputLabel>Core Category</InputLabel>
        <Select
          value={selectedMealPlan.coreCategory || ""}
          onChange={(e) => setSelectedMealPlan((prev) => ({ ...prev, coreCategory: e.target.value }))}
          label="Core Category"
        >
          <MenuItem value="">Select Core Category</MenuItem>
          <MenuItem value="Vegetables">Vegetables</MenuItem>
          <MenuItem value="Proteins">Proteins</MenuItem>
          <MenuItem value="Grains">Grains</MenuItem>
          <MenuItem value="Dairy">Dairy</MenuItem>
          <MenuItem value="Fruits">Fruits</MenuItem>
          <MenuItem value="Nuts">Nuts</MenuItem>
          <MenuItem value="Spices">Spices</MenuItem>
          <MenuItem value="Oils">Oils</MenuItem>
          <MenuItem value="Beverages">Beverages</MenuItem>
          <MenuItem value="Seafood">Seafood</MenuItem>
          <MenuItem value="Meat">Meat</MenuItem>
          <MenuItem value="Poultry">Poultry</MenuItem>
          <MenuItem value="Legumes">Legumes</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </Select>
      </FormControl>
      
      <FormControl fullWidth>
        <InputLabel>Category</InputLabel>
        <Select
          value={selectedMealPlan.category || ""}
          onChange={(e) => setSelectedMealPlan((prev) => ({ ...prev, category: e.target.value }))}
          label="Category"
        >
          <MenuItem value="">Select Category</MenuItem>
          <MenuItem value="Vegetables">Vegetables</MenuItem>
          <MenuItem value="Proteins">Proteins</MenuItem>
          <MenuItem value="Grains">Grains</MenuItem>
          <MenuItem value="Dairy">Dairy</MenuItem>
          <MenuItem value="Fruits">Fruits</MenuItem>
          <MenuItem value="Nuts">Nuts</MenuItem>
          <MenuItem value="Spices">Spices</MenuItem>
          <MenuItem value="Oils">Oils</MenuItem>
          <MenuItem value="Beverages">Beverages</MenuItem>
          <MenuItem value="Seafood">Seafood</MenuItem>
          <MenuItem value="Meat">Meat</MenuItem>
          <MenuItem value="Poultry">Poultry</MenuItem>
          <MenuItem value="Legumes">Legumes</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </Select>
      </FormControl>
    </Box>
    
    <Box display="flex" gap={2} mb={2}>
      <TextField
        fullWidth
        label="Sub Category"
        value={selectedMealPlan.subCategory || ""}
        onChange={(e) => setSelectedMealPlan((prev) => ({ ...prev, subCategory: e.target.value }))}
        placeholder="e.g., leafy greens, root vegetables, etc."
      />
      
      <FormControl fullWidth>
        <InputLabel>FODMAP Level</InputLabel>
        <Select
          value={selectedMealPlan.fod_map?.value || ""}
          onChange={(e) => setSelectedMealPlan((prev) => ({ 
            ...prev, 
            fod_map: { ...prev.fod_map, value: e.target.value }
          }))}
          label="FODMAP Level"
        >
          <MenuItem value="">Select FODMAP Level</MenuItem>
          <MenuItem value="Low">Low FODMAP</MenuItem>
          <MenuItem value="Moderate">Moderate FODMAP</MenuItem>
          <MenuItem value="High">High FODMAP</MenuItem>
        </Select>
      </FormControl>
    </Box>
    
    <Box display="flex" gap={2} mb={2}>
      <FormControl fullWidth>
        <InputLabel>Source</InputLabel>
        <Select
          value={selectedMealPlan.source || ""}
          onChange={(e) => setSelectedMealPlan((prev) => ({ ...prev, source: e.target.value }))}
          label="Source"
        >
          <MenuItem value="ChatGPT">ChatGPT</MenuItem>
          <MenuItem value="Manual">Manual</MenuItem>
        </Select>
      </FormControl>
    </Box>

<Typography variant="subtitle1" sx={{ mt: 3 }}>
  Tags
</Typography>

<Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
  {selectedMealPlan.tags?.map((tag, idx) => (
    <Chip
      key={idx}
      label={tag}
      onDelete={() => {
        setSelectedMealPlan((prev) => ({
          ...prev,
          tags: prev.tags.filter((t) => t !== tag),
        }));
      }}
      color="primary"
      variant="outlined"
    />
  ))}
</Box>

<Box sx={{ display: "flex", gap: 1, mb: 2 }}>
  <TextField
    label="Add Tag"
    size="small"
    value={newTag}
    onChange={(e) => setNewTag(e.target.value)}
    onKeyDown={(e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        addTag();
      }
    }}
  />
  <Button variant="contained" onClick={addTag}>
    Add
  </Button>
</Box>

    <Box display="flex" gap={2} mb={2}>
      <TextField
        label="Quantity"
        value={selectedMealPlan.quantity?.value}
        onChange={(e) =>
          setSelectedMealPlan((prev) => ({
            ...prev,
            quantity: { ...prev.quantity, value: e.target.value },
          }))
        }
      />
      <TextField
        label="Unit"
        value={selectedMealPlan.quantity?.unit}
        onChange={(e) =>
          setSelectedMealPlan((prev) => ({
            ...prev,
            quantity: { ...prev.quantity, unit: e.target.value },
          }))
        }
      />
    </Box>

    <Typography variant="subtitle1">Nutrition</Typography>
    <Box display="flex" gap={2} flexWrap="wrap" mb={2}>
      {["calories", "protein", "carbs", "fat", "fiber"].map((key) => (
        <TextField
          key={key}
          label={key}
          value={selectedMealPlan.nutrition?.[key]}
          onChange={(e) =>
            setSelectedMealPlan((prev) => ({
              ...prev,
              nutrition: { ...prev.nutrition, [key]: e.target.value },
            }))
          }
        />
      ))}
    </Box>
<Typography variant="subtitle1" sx={{ p: 2 }}>
    recipe
  </Typography>
    <Paper variant="outlined" sx={{ mt: 2 }}>
  <Typography variant="subtitle1" sx={{ p: 2 }}>
    Ingredients
  </Typography>
  <Table>
    <TableHead>
      <TableRow>
        <TableCell>Item</TableCell>
        <TableCell>Quantity</TableCell>
        <TableCell>Unit</TableCell>
        <TableCell>Category</TableCell>
        <TableCell>Actions</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {selectedMealPlan.recipe?.ingredients?.map((ingredient, i) => (
        <TableRow key={i}>
          <TableCell>
            <TextField
              value={ingredient.item}
              onChange={(e) => {
                const newIngredients = [...selectedMealPlan.recipe.ingredients];
                newIngredients[i].item = e.target.value;
                setSelectedMealPlan((prev) => ({
                  ...prev,
                  recipe: { ...prev.recipe, ingredients: newIngredients },
                }));
              }}
            />
          </TableCell>
          <TableCell>
            <TextField
              value={ingredient.quantity}
              onChange={(e) => {
                const newIngredients = [...selectedMealPlan.recipe.ingredients];
                newIngredients[i].quantity = e.target.value;
                setSelectedMealPlan((prev) => ({
                  ...prev,
                  recipe: { ...prev.recipe, ingredients: newIngredients },
                }));
              }}
            />
          </TableCell>
          <TableCell>
            <TextField
              value={ingredient.unit}
              onChange={(e) => {
                const newIngredients = [...selectedMealPlan.recipe.ingredients];
                newIngredients[i].unit = e.target.value;
                setSelectedMealPlan((prev) => ({
                  ...prev,
                  recipe: { ...prev.recipe, ingredients: newIngredients },
                }));
              }}
            />
          </TableCell>
          <TableCell>
            <FormControl fullWidth size="small">
              <Select
                value={ingredient.category || ""}
                onChange={(e) => {
                  const newIngredients = [...selectedMealPlan.recipe.ingredients];
                  newIngredients[i].category = e.target.value;
                  setSelectedMealPlan((prev) => ({
                    ...prev,
                    recipe: { ...prev.recipe, ingredients: newIngredients },
                  }));
                }}
                displayEmpty
              >
                <MenuItem value="">
                  <em>Select Category</em>
                </MenuItem>
                {ingredientCategories.map((category) => (
                  <MenuItem key={category} value={category}>
                    {category}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </TableCell>
          <TableCell>
            <Button
              color="error"
              onClick={() => {
                const newIngredients = selectedMealPlan.recipe.ingredients.filter(
                  (_, idx) => idx !== i
                );
                setSelectedMealPlan((prev) => ({
                  ...prev,
                  recipe: { ...prev.recipe, ingredients: newIngredients },
                }));
              }}
            >
              Remove
            </Button>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>

  {/* Add Ingredient Button */}
  <Box sx={{ p: 2 }}>
    <Button
      variant="outlined"
      onClick={() => {
        const newIngredients = [
          ...(selectedMealPlan.recipe?.ingredients || []),
          { item: "", quantity: "", unit: "", category: "" }, // empty ingredient row
        ];
        setSelectedMealPlan((prev) => ({
          ...prev,
          recipe: { ...prev.recipe, ingredients: newIngredients },
        }));
      }}
    >
      + Add Ingredient
    </Button>
  </Box>

  {/* Preparation Steps */}
  <Box sx={{ p: 2 }}>
    <Typography variant="subtitle1">Preparation Steps</Typography>
    <ol>
      {selectedMealPlan.recipe?.preparationSteps?.map((step, i) => (
        <li key={i}>
          <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
            <TextField
              fullWidth
              value={step}
              onChange={(e) => {
                const steps = [...selectedMealPlan.recipe.preparationSteps];
                steps[i] = e.target.value;
                setSelectedMealPlan((prev) => ({
                  ...prev,
                  recipe: { ...prev.recipe, preparationSteps: steps },
                }));
              }}
              placeholder={`Step ${i + 1}`}
            />
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={() => {
                const steps = selectedMealPlan.recipe.preparationSteps.filter((_, index) => index !== i);
                setSelectedMealPlan((prev) => ({
                  ...prev,
                  recipe: { ...prev.recipe, preparationSteps: steps },
                }));
              }}
            >
              Remove
            </Button>
          </Box>
        </li>
      ))}
    </ol>
    
    {/* Add new step button */}
    <Box sx={{ mb: 2 }}>
      <Button
        variant="outlined"
        size="small"
        onClick={() => {
          const currentSteps = selectedMealPlan.recipe?.preparationSteps || [];
          setSelectedMealPlan((prev) => ({
            ...prev,
            recipe: { 
              ...prev.recipe, 
              preparationSteps: [...currentSteps, ""] 
            },
          }));
        }}
      >
        + Add Preparation Step
      </Button>
    </Box>

    {/* Preparation Time */}
    <TextField
      label="Preparation Time (minutes)"
      type="number"
      value={selectedMealPlan.recipe?.preparationTime || ""}
      onChange={(e) =>
        setSelectedMealPlan((prev) => ({
          ...prev,
          recipe: { ...prev.recipe, preparationTime: parseInt(e.target.value) || 0 },
        }))
      }
      sx={{ width: 200 }}
    />
  </Box>
  <Paper variant="outlined" sx={{ mt: 2 }}>
  <Typography variant="subtitle1" sx={{ p: 2 }}>
    Benefits
  </Typography>
  <Table>
    <TableBody>
      {selectedMealPlan?.benefits?.map((benefit, i) => (
        <TableRow key={i}>
          <TableCell>
            <TextField
              fullWidth
              value={benefit}
              onChange={(e) => {
                const newBenefits = [...selectedMealPlan.benefits];
                newBenefits[i] = e.target.value;
                setSelectedMealPlan((prev) => ({
                  ...prev,
                  benefits: newBenefits,
                }));
              }}
            />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>

  {/* Add benefit button */}
  <Box sx={{ p: 2 }}>
    <Button
      variant="outlined"
      size="small"
      onClick={() =>
        setSelectedMealPlan((prev) => ({
          ...prev,
          benefits: [...(prev.benefits || []), ""],
        }))
      }
    >
      + Add Benefit
    </Button>
  </Box>
</Paper>

</Paper>



    {/* Alternatives Section */}
    <Paper variant="outlined" sx={{ mt: 2 }}>
      <Typography variant="subtitle1" sx={{ p: 2 }}>
        Alternative Meals
      </Typography>
      
      {selectedMealPlan.alternatives?.length > 0 ? (
        <Box sx={{ p: 2 }}>
          {selectedMealPlan.alternatives.map((alt, i) => (
            <Box key={i} sx={{ mb: 2, p: 2, border: 1, borderColor: 'divider', borderRadius: 1 }}>
              <Box sx={{ display: 'flex', gap: 1, mb: 1, flexWrap: 'wrap' }}>
                <TextField
                  label="Name"
                  value={alt.name || ''}
                  onChange={(e) => {
                    const newAlts = [...selectedMealPlan.alternatives];
                    newAlts[i].name = e.target.value;
                    setSelectedMealPlan((prev) => ({ ...prev, alternatives: newAlts }));
                  }}
                  sx={{ minWidth: 200 }}
                />
                <TextField
                  label="Core Category"
                  value={alt.coreCategory || ''}
                  onChange={(e) => {
                    const newAlts = [...selectedMealPlan.alternatives];
                    newAlts[i].coreCategory = e.target.value;
                    setSelectedMealPlan((prev) => ({ ...prev, alternatives: newAlts }));
                  }}
                  sx={{ minWidth: 150 }}
                />
                <TextField
                  label="Category"
                  value={alt.category || ''}
                  onChange={(e) => {
                    const newAlts = [...selectedMealPlan.alternatives];
                    newAlts[i].category = e.target.value;
                    setSelectedMealPlan((prev) => ({ ...prev, alternatives: newAlts }));
                  }}
                  sx={{ minWidth: 150 }}
                />
                <TextField
                  label="Sub Category"
                  value={alt.subCategory || ''}
                  onChange={(e) => {
                    const newAlts = [...selectedMealPlan.alternatives];
                    newAlts[i].subCategory = e.target.value;
                    setSelectedMealPlan((prev) => ({ ...prev, alternatives: newAlts }));
                  }}
                  sx={{ minWidth: 150 }}
                />
              </Box>
              
              <Box sx={{ display: 'flex', gap: 1, mb: 1, flexWrap: 'wrap' }}>
                <TextField
                  label="Quantity Value"
                  type="number"
                  value={alt.quantity?.value || ''}
                  onChange={(e) => {
                    const newAlts = [...selectedMealPlan.alternatives];
                    newAlts[i].quantity = { ...newAlts[i].quantity, value: Number(e.target.value) || 0 };
                    setSelectedMealPlan((prev) => ({ ...prev, alternatives: newAlts }));
                  }}
                  sx={{ minWidth: 120 }}
                />
                <TextField
                  label="Unit"
                  value={alt.quantity?.unit || ''}
                  onChange={(e) => {
                    const newAlts = [...selectedMealPlan.alternatives];
                    newAlts[i].quantity = { ...newAlts[i].quantity, unit: e.target.value };
                    setSelectedMealPlan((prev) => ({ ...prev, alternatives: newAlts }));
                  }}
                  sx={{ minWidth: 100 }}
                />
                <TextField
                  label="FODMAP"
                  select
                  value={alt.fod_map?.value || ''}
                  onChange={(e) => {
                    const newAlts = [...selectedMealPlan.alternatives];
                    newAlts[i].fod_map = { value: e.target.value };
                    setSelectedMealPlan((prev) => ({ ...prev, alternatives: newAlts }));
                  }}
                  sx={{ minWidth: 120 }}
                >
                  <MenuItem value="">Select FODMAP</MenuItem>
                  <MenuItem value="High">High</MenuItem>
                  <MenuItem value="Moderate">Moderate</MenuItem>
                  <MenuItem value="Low">Low</MenuItem>
                </TextField>
              </Box>
              
              <Box sx={{ display: 'flex', gap: 1, mb: 1, flexWrap: 'wrap' }}>
                <TextField
                  label="Calories"
                  type="number"
                  value={alt.nutrition?.calories || ''}
                  onChange={(e) => {
                    const newAlts = [...selectedMealPlan.alternatives];
                    newAlts[i].nutrition = { ...newAlts[i].nutrition, calories: Number(e.target.value) || 0 };
                    setSelectedMealPlan((prev) => ({ ...prev, alternatives: newAlts }));
                  }}
                  sx={{ minWidth: 100 }}
                />
                <TextField
                  label="Protein"
                  type="number"
                  value={alt.nutrition?.protein || ''}
                  onChange={(e) => {
                    const newAlts = [...selectedMealPlan.alternatives];
                    newAlts[i].nutrition = { ...newAlts[i].nutrition, protein: Number(e.target.value) || 0 };
                    setSelectedMealPlan((prev) => ({ ...prev, alternatives: newAlts }));
                  }}
                  sx={{ minWidth: 100 }}
                />
                <TextField
                  label="Carbs"
                  type="number"
                  value={alt.nutrition?.carbs || ''}
                  onChange={(e) => {
                    const newAlts = [...selectedMealPlan.alternatives];
                    newAlts[i].nutrition = { ...newAlts[i].nutrition, carbs: Number(e.target.value) || 0 };
                    setSelectedMealPlan((prev) => ({ ...prev, alternatives: newAlts }));
                  }}
                  sx={{ minWidth: 100 }}
                />
                <TextField
                  label="Fiber"
                  type="number"
                  value={alt.nutrition?.fiber || ''}
                  onChange={(e) => {
                    const newAlts = [...selectedMealPlan.alternatives];
                    newAlts[i].nutrition = { ...newAlts[i].nutrition, fiber: Number(e.target.value) || 0 };
                    setSelectedMealPlan((prev) => ({ ...prev, alternatives: newAlts }));
                  }}
                  sx={{ minWidth: 100 }}
                />
                <TextField
                  label="Fat"
                  type="number"
                  value={alt.nutrition?.fat || ''}
                  onChange={(e) => {
                    const newAlts = [...selectedMealPlan.alternatives];
                    newAlts[i].nutrition = { ...newAlts[i].nutrition, fat: Number(e.target.value) || 0 };
                    setSelectedMealPlan((prev) => ({ ...prev, alternatives: newAlts }));
                  }}
                  sx={{ minWidth: 100 }}
                />
              </Box>
              
              <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={() => {
                    const newAlts = selectedMealPlan.alternatives.filter((_, index) => index !== i);
                    setSelectedMealPlan((prev) => ({ ...prev, alternatives: newAlts }));
                  }}
                >
                  Remove Alternative
                </Button>
              </Box>
            </Box>
          ))}
        </Box>
      ) : (
        <Box sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
          <Typography variant="body2">No alternative meals added yet</Typography>
        </Box>
      )}
      
      {/* Add Alternative Button */}
      <Box sx={{ p: 2, borderTop: 1, borderColor: 'divider' }}>
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            const currentAlternatives = selectedMealPlan.alternatives || [];
            const newAlternative = {
              name: '',
              coreCategory: '',
              category: '',
              subCategory: '',
              fod_map: { value: '' },
              nutrition: {
                calories: 0,
                protein: 0,
                carbs: 0,
                fiber: 0,
                fat: 0
              },
              quantity: {
                value: 0,
                unit: ''
              },
              recipe: {
                ingredients: [],
                preparationSteps: [],
                preparationTime: 0
              },
              benefits: []
            };
            setSelectedMealPlan((prev) => ({
              ...prev,
              alternatives: [...currentAlternatives, newAlternative]
            }));
          }}
        >
          + Add Alternative Meal
        </Button>
      </Box>
    </Paper>
  </DialogContent>

  <DialogActions>
    <Button onClick={() => {
      setEditModal(false);
      // Reset edit image states when closing modal
      setEditImageFile(null);
      setEditImagePreview(null);
      setUploadingEditImage(false);
    }}>Cancel</Button>
    <Button
      variant="contained"
      onClick={()=> handleSave()}
    >
      Save
    </Button>
  </DialogActions>
</Dialog>

      {/* Image Upload Modal */}
      <Dialog
        open={imageUploadModal}
        onClose={handleCloseImageModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Upload Image for {selectedFoodForImage?.patientName}
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="image-upload"
              type="file"
              onChange={handleImageFileChange}
            />
            <label htmlFor="image-upload">
              <Button
                variant="outlined"
                component="span"
                startIcon={<PhotoCameraIcon />}
                fullWidth
              >
                Choose Image
              </Button>
            </label>
            
            {imagePreview && (
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="subtitle2" gutterBottom>
                  Preview:
                </Typography>
                <img
                  src={imagePreview}
                  alt="Preview"
                  style={{
                    maxWidth: '100%',
                    maxHeight: 300,
                    objectFit: 'contain',
                    borderRadius: 8,
                    border: '1px solid #e0e0e0'
                  }}
                />
              </Box>
            )}
            
            {selectedFoodForImage?.image && (
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="subtitle2" gutterBottom>
                  Current Image:
                </Typography>
                <img
                  src={selectedFoodForImage.image}
                  alt="Current"
                  style={{
                    maxWidth: '100%',
                    maxHeight: 200,
                    objectFit: 'contain',
                    borderRadius: 8,
                    border: '1px solid #e0e0e0'
                  }}
                />
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImageModal}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleImageUploadSubmit}
            disabled={!imageFile || uploadingImage}
            startIcon={uploadingImage ? <CircularProgress size={20} /> : <PhotoCameraIcon />}
          >
            {uploadingImage ? 'Uploading...' : 'Upload Image'}
          </Button>
        </DialogActions>
      </Dialog>
           
        </div>
      </Layout>
      
    </>
  );
};

export default MasterFood;
